export default __webpack_public_path__ + "static/media/sample.77b34362.svg";